import Alert from '@vromo/ui/components/Alert';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface Props {
    errors: { error: string; field: string; message: string }[];
    field: string;
}

const Errors = observer(({ errors, field }: Props) => (
    <div>
        {errors
            .filter((error) => error.field === field)
            .map((error, ix) => (
                <Alert key={ix} success={!error.error} danger={!!error.error}>
                    {error.message}
                </Alert>
            ))}
    </div>
));

export default Errors;
